<template>
<div class="terms">
    <div class="description" v-html="pageText"></div>
  </div>
</template>

<script>
import PageHTML from '@/views/html/privacy.html';

export default {
  name: 'Privacy',
  metaInfo: {
    title: 'ВХ для КС - Политика конфиденциальности',
    link: [
      { rel: 'canonical', href: 'https://cssoftshop.ru/privacy' },
    ],
    meta: [
      { name: 'description', content: 'Политика конфиденциальности' },
    ],
  },
  data() {
    return {
      pageText: PageHTML,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

.description
    color: white
    text-align: left
    max-width: 900px
    margin: 0px auto
</style>
